import store from '@/store';

export default (to, from, next) => ({
  allow: store.getters.is_account_email_verified,
  redirect: { name: store.getters.is_account ? 'email-verify-page' : 'sign-in' },
});